import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import { publisherManager, soundcastManager } from '../../../../helpers/managers';
import { Select, LoadingWrapper } from '../../../../styles/styled';
import Loading from '../../../../components/Loading';
import MailchimpWizard from './MailchimpWizard';

// wizards
const integrationWizards = {
  mailchimp: MailchimpWizard,
};

// firebase props
const integrationKeys = {
  mailchimp: 'mailChimp',
};

class IntegrationWizard extends Component {
  constructor(props) {
    super(props);

    const { soundcastId } = props;
    this.state = {
      loading: true,
      app: 'mailchimp',
      invalid: false,
      integration: {},
      soundcastId,
    };
  }

  componentDidMount() {
    const { userInfo } = this.props;
    if (!('publisherID' in userInfo)) {
      return false;
    }

    this.getSoundcastIntegrationValue();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.soundcastId !== this.state.soundcastId) {
      this.getSoundcastIntegrationValue();
    }
  }

  async getSoundcastIntegrationValue() {
    const propkey = this.getSoundcastIntegrationkey();
    if (!propkey) {
      return this.setState({
        invalid: true,
      });
    }

    // assuming that all future integrations
    // are going to create right propkey to publishers node
    const { userInfo } = this.props;
    const { soundcastId } = this.state;
    const { publisherID } = userInfo;

    const integrationConfig = await publisherManager.getProp(publisherID, `${propkey}`);
    if (isNull(integrationConfig)) {
      return this.setState({
        invalid: true,
      });
    }

    // get the same integration data from soundcast
    const integrationValue = await soundcastManager.getProp(soundcastId, `${propkey}`, {});

    this.setState({
      loading: false,
      integration: {
        config: integrationConfig,
        value: integrationValue,
      },
    });
  }

  onChangeTargetApp = e => {
    this.setState({
      app: e.target.value || '',
    });
  };

  changeSoundcastId = e => {
    this.setState({
      soundcastId: e.target.value || '',
      loading: true,
    });
  };

  getSoundcastIntegrationkey() {
    const { app } = this.state;
    if (!(app in integrationKeys)) {
      return false;
    }

    return integrationKeys[app];
  }

  save() {
    this.wizardRef.save();
  }

  renderWizard() {
    const { app, loading, invalid, integration, soundcastId } = this.state;
    if (invalid) {
      return (
        <div className="alert alert-danger text-medium" role="alert">
          Invalid integration please contact support.
        </div>
      );
    }

    if (loading) {
      return (
        <LoadingWrapper height="10">
          <Loading text="Loading Integration" />
        </LoadingWrapper>
      );
    }

    if (app in integrationWizards) {
      const Component = integrationWizards[app];
      return (
        <Component
          {...this.props}
          ref={ref => (this.wizardRef = ref)}
          integration={integration}
          soundcastId={soundcastId}
        />
      );
    }

    return null;
  }

  render() {
    const { app, soundcastId } = this.state;
    const { soundcasts } = this.props;

    return (
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="text-large font-weight-600">Choose Soundcast</div>
          <div className="text-medium">Select the soundcast you want to export subscribers to</div>
          <div className="padding-one-top">
            <Select className="text-large" value={soundcastId} onChange={this.changeSoundcastId}>
              {isEmpty(soundcasts) && <option>Loading...</option>}
              {soundcasts.map(({ id, title }, i) => {
                return (
                  <option value={id} key={i}>
                    {title}
                  </option>
                );
              })}
            </Select>
          </div>
        </div>
        <div className="col-lg-12 col-md-12">
          <div className="text-large font-weight-600">Choose Integration</div>
          <div className="text-medium">Select the integration where to export subscribers</div>
          <div className="padding-one-top">
            <Select className="text-large" value={app} onChange={this.onChangeTargetApp}>
              <option value="mailchimp">MailChimp</option>
            </Select>
          </div>
        </div>
        <div className="col-lg-12 col-md-12">{this.renderWizard()}</div>
      </div>
    );
  }
}

IntegrationWizard.propTypes = {
  soundcastId: PropTypes.string,
  soundcasts: PropTypes.array,
  userInfo: PropTypes.object,
};

IntegrationWizard.defaultProps = {
  soundcastId: '',
  soundcasts: [],
  userInfo: {},
};

export default IntegrationWizard;
